export default "__VITE_ASSET__DwtJpQC4__"